
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  Flits(document).on('Flits:Navigation:Loaded', function(event){
    var settings = event.detail.settings;
    var obj = {
      title: 'FAQ',
      url:'#faq',
      target:0,
      badge: null,
      icon: null,
      isShow: 4,
      loader:null,
      body_html: '<div></div>'
    }
    settings.navs.splice(5, 0, obj);
  });

  Flits(document).on("Flits:AccountPage:Visible", function(){
    if(Flits('#flits_tab_faq').length){
      fetch("/pages/new-faq").then(function(response) {
        return response.text();
      }).then(function(html) {
        const pageData = document.createElement("div");
        pageData.innerHTML = html;
        var mainInner = pageData.querySelector(".que-ans-section").innerHTML;
        if(mainInner){
          Flits('#flits_tab_faq .flits-tab-box-body').append(mainInner);
          // Flits('#flits_mobile_tab_faq .flits-mobile-container-box .flits-mobile-box-card').append(mainInner);
        }
      });
    }
  });

  Flits(document).on("Flits:AccountPage:Loaded", function(){
    Flits(document).on('click', '.faq-icon-box', function() {
      var main_faq_div = Flits(this).parent().parent();
      if(Flits(main_faq_div).hasClass("active")){
        Flits(main_faq_div).find(".answer").slideUp();
        Flits(main_faq_div).removeClass("active");
      }
      else{
        Flits(".queans__main ").removeClass("active");
        Flits(".queans__main .answer").slideUp();
        Flits(main_faq_div).addClass("active");
        Flits(main_faq_div).find(".answer").slideDown();
      }
    });
  });
}(Flits));
